module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/linkedin-white-5ef3e82e52b11131a10d5a85f52ff211.svg";